import { Button, message } from "antd";

import { useParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Box,
  Typography,
  Paper,
  Grid,
  TextField,
  Fade,
  Slide,
} from "@mui/material";

const UpdateGps = ({ storeProducts }) => {
  const { id } = useParams();
  const product = Array.isArray(storeProducts)
    ? storeProducts.find((item) => item.id === parseInt(id))
    : null;

  const [name, setName] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (product) {
      try {
        setName(product.name || "");
      } catch (error) {
        console.error("Error parsing product fields:", error);
      }
    }
  }, [product]);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim()) {
      message.error("Name is required");
      return;
    }

    setSubmitting(true);
    try {
      const updatedValues = {
        name: name.trim(),
      };

      const response = await axios.put(
        `https://uktomars.co.uk/api/gps-device/${id}`,
        updatedValues
      );

      if (response.status === 200) {
        message.success("Successfully updated");
        window.location.href = "/";
      }
    } catch (error) {
      console.error("Error updating GPS device:", error);
      message.error("Failed to update");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Fade in={true} timeout={500}>
      <Box sx={{ maxWidth: 800, mx: "auto", my: 5, px: 2 }}>
        <Slide direction="up" in={true} timeout={400}>
          <Paper elevation={6} sx={{ p: { xs: 2, md: 4 }, borderRadius: 3 }}>
            <Box component="form" onSubmit={onSubmit}>
              <Box sx={{ textAlign: "center", mb: 3 }}>
                <Typography variant="h5" sx={{ fontWeight: 700 }}>
                  Update GPS Device
                </Typography>
              </Box>

              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Name"
                    placeholder="Type your name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                    sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2 } }}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Box
                    sx={{ display: "flex", gap: 2, justifyContent: "center" }}
                  >
                    <Button
                      type="default"
                      onClick={() => (window.location.href = "/")}
                    >
                      Cancel
                    </Button>
                    <Button
                      type="primary"
                      htmlType="submit"
                      disabled={submitting}
                    >
                      {submitting ? "Submitting..." : "Submit"}
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Paper>
        </Slide>
      </Box>
    </Fade>
  );
};

export default UpdateGps;
